import { render, staticRenderFns } from "./CarePopup.vue?vue&type=template&id=5133e18e&scoped=true&"
import script from "./CarePopup.vue?vue&type=script&lang=js&"
export * from "./CarePopup.vue?vue&type=script&lang=js&"
import style0 from "./CarePopup.vue?vue&type=style&index=0&id=5133e18e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133e18e",
  null
  
)

export default component.exports